module.exports = __webpack_public_path__ + "static/media/credit_card.4a4e4dee.svg";